<template>
  <div class="main-content pt40">
    <div class="goods-info">
      <div class="image-info">
        <div class="goods-image">
          <template v-if="images[activeIndex] && images[activeIndex].indexOf('.mp4') !== -1">
            <video-player
              class="video-player vjs-custom-skin video-wrapper"
              ref="videoPlayer"
              :playsinline="true"
              :options="getPlayerOptions"
            ></video-player>
          </template>
          <img :src="images[activeIndex]" class="imagecontain" v-else />
        </div>
        <div class="pagination-wrapper">
          <div class="image-pagination" id="pagination">
            <div class="pagination-content">
              <div class="pagination-item" :class="activeIndex == index ? 'pagination-item-active':''" 
                :style="{ backgroundImage: image.indexOf('.mp4') !== -1 ? ('url(' + productImage + ')') : ('url(' + image + ')') }" 
                @click="slideTo(null, index)"
                v-for="(image, index) in images" :key="index" >
                <img src="@/assets/images/video_3.png" v-if="image.indexOf('.mp4') !== -1" class="video-icon" />
              </div>
            </div>
          </div>
          <div class="pagination-btn pagination-prev" @click="slideTo(-1)">
            <img src="../../assets/images/pagi-prev.png" class="imagecontain" />
          </div>
          <div class="pagination-btn pagination-next" @click="slideTo(1)">
            <img src="../../assets/images/pagi-next.png" class="imagecontain" />
          </div>
        </div>
      </div>
      <div class="goods-msg">
        <div class="goods-name">{{storeInfo.storeName}}</div>
        <div class="goods-about">
          <!-- <span class="mr30">重量：{{info.weight}}</span> -->
          <span>库存：{{storeInfo.stock}}</span>
        </div>
        <el-divider></el-divider>
        <div class="msg-line">
          <span class="line-label">价格</span>
          <div class="line-content">
            <span class="goods-price">￥{{productValue[activeAttr].price}}</span>
            <span class="goods-origin" v-if="productValue[activeAttr].otPrice">￥{{productValue[activeAttr].otPrice}}</span>
          </div>
        </div>
        <div class="msg-line">
          <span class="line-label">规格</span>
          <div class="line-content">
            <span class="attr-item" :class="activeAttr == idx ? 'attr-item-active':''" @click="attrClick(attr, idx)"
              v-for="(attr, idx) in info.productValue" :key="idx">{{idx}}</span>
          </div>
        </div>
        <!-- <div class="msg-line">
          <span class="line-label">数量</span>
          <div class="line-content">
            <div class="input-number-container">
              <el-input-number v-model="count" :precision="0" :min="1" :max="999" size="medium"></el-input-number>
            </div>
          </div>
        </div> -->
        <div class="msg-line mt20">
          <span class="line-label"></span>
          <div class="line-content">
            <span class="submit-btn" @click="payClick" v-if="productId">立即购买</span>
          </div>
        </div>
      </div>
    </div>
    <div class="goods-detail">
      <div class="detail-title">商品详情</div>
      <div class="detail-content" v-html="storeInfo.description">
        <!-- <img src="https://admin.gdyfpt.com/file/pic/20201211151839437185.png" /> -->
      </div>
    </div>
    <el-dialog title="微信扫码" :visible.sync="visible" width="400px">
      <div id="qrcode" class="qrcode"></div>
      <div class="qrcode-tip">微信扫码进入移动端商城</div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="visible = false">确 定</el-button>
      </span> -->
    </el-dialog>
  </div>
</template>

<script>
import { loadProductDetail } from '@/api/api'
import Scroller from '@/utils/scroll';
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      activeIndex: 0,
      images: [],
      // images的第一张图
      productImage: '',
      count: 1,
      visible: false,
      info: {},
      storeInfo: {},
      productValue: [],
      activeAttr: '',
      productId: ''
    }
  },
  mounted() {
    if(this.$route.params.id) {
      this.productId = this.$route.params.id
      this.loadDetail()
    }
    new Scroller('pagination')
  },
  computed: {
    getPlayerOptions() {
      return {
        playbackRates: [0.5, 1.0, 1.5, 2.0, 4.0, 8.0], //可选择的播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "",
            src: this.images[this.activeIndex] //url地址
          }
        ],
        poster: this.productImage, //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, //当前时间和持续时间的分隔符
          durationDisplay: true, //显示持续时间
          remainingTimeDisplay: false, //是否显示剩余时间功能
          fullscreenToggle: true //全屏按钮
        }
      }
    }
  },
  methods: {
    attrClick(attr, index) {
      this.activeAttr = index
    },
    loadDetail() {
      loadProductDetail(this.productId).then(res => {
        if(res.success) {
          this.info = res.data
          this.storeInfo = res.data.storeInfo
          this.images = this.storeInfo.sliderImageArr ? this.storeInfo.sliderImageArr : []
          this.productValue = res.data.productValue
          for(let x in this.productValue) {
            this.activeAttr = x
            break
          }
          for(let x in this.images) {
            if(this.images[x].indexOf('.mp4') === -1) {
              this.productImage = this.images[x]
              break
            }
          }
        }
      })
    },
    payClick() {
      const self = this
      this.visible = true
      this.$nextTick(() => {
        document.getElementById("qrcode").innerHTML = "";
        self.rqcode = new QRCode(document.getElementById("qrcode"), {
          width: 144,
          height: 144, // 高度
          text: `https://admin.gdyfpt.com/product/?productId=${this.productId}&pageType=good&codeType=routine`
          // text: 'https://admin.gdyfpt.com/product/?productId=2&spread=34&pageType=good&codeType=routine' // 二维码内容
        });
      })
    },
    slideTo(val, locate) {
      var index = this.activeIndex
      if(val) {
        index += val
        if(index >= this.images.length) {
          index = 0
        } else if(index < 0) {
          index = this.images.length - 1
        }
      } else {
        index = locate
      }
      this.activeIndex = index

      var distanceLeft = index * 84
      // var outDom = document.getElementById('pagination')
      // outDom.scrollLeft = distanceLeft
      // eslint-disable-next-line
      $('#pagination').animate({ scrollLeft: distanceLeft }, 200, 'swing', function() { console.log('done') });
    }
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/styles/color.scss';
  .video-icon {
    width: 40px; 
    height: 40px;
    object-fit: contain;
    margin: 20px auto;
  }
  .goods-info {
    position: relative;
    overflow: hidden;
    margin-bottom: 50px;
    .image-info {
      float: left;
      width: 480px;
      .goods-image {
        width: 480px;
        height: 480px;
      }
      .pagination-wrapper {
        width: 100%;
        position: relative;
        .pagination-btn {
          position: absolute;
          width: 14px;
          height: 54px;
          // border: 1px solid #999999;
          top: 50%;
          transform: translateY(-50%);
          cursor: pointer;
          &.pagination-prev {
            left: 0;
          }
          &.pagination-next {
            right: 0;
          }
        }
      }
      .image-pagination {
        position: relative;
        padding: 10px 0;
        margin: 0 16px;
        font-size: 0;
        overflow-x: auto;
        overflow-y: hidden;
        &::-webkit-scrollbar {
          display: none;
        }
        .pagination-content {
          width: 100%;
          overflow: hidden;
          text-align: center;
          white-space: nowrap;
          width: min-content;
          margin: 0 auto;
        }
        .pagination-item {
          display: inline-block;
          width: 80px;
          height: 80px;
          margin-right: 4px;
          cursor: pointer;
          background-size: cover;
          border: 1px solid transparent;
          vertical-align: middle;
          &.pagination-item-active {
            border-color: $primary-color;
          }
          &:last-child {
            margin: 0;
          }
        }
      }
    }
    .goods-msg {
      width: 720px;
      padding-left: 60px;
      margin-left: 480px;
      .goods-name {
        line-height: 26px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        margin-bottom: 10px;
      }
      .goods-about {
        line-height: 20px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
      }
      .msg-line {
        line-height: 34px;
        display: flex;
        align-items: center;
        margin-bottom: 14px;
        .line-label {
          width: 60px;
          min-width: 60px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          letter-spacing: 10px;
        }
        .line-content {
          flex: 1;
        }
        .submit-btn {
          display: block;
          width: 366px;
          height: 40px;
          line-height: 38px;
          background: #FFEBE9;
          border: 1px solid #FF6C0B;
          border-radius: 4px;
          text-align: center;
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #FF6C0B;
          cursor: pointer;
        }
        .goods-price {
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #FF6C0B;
          margin-right: 10px;
        }
        .goods-origin {
          font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
          text-decoration: line-through;
        }
        .attr-item {
          display: inline-block;
          padding: 0 12px;
          height: 30px;
          line-height: 28px;
          background: #FFFFFF;
          border: 1px solid #999999;
          border-radius: 4px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          margin-right: 10px;
          cursor: pointer;
          &.attr-item-active {
            background: #FFEBE9;
            border: 1px solid #FF6C0B;
          }
        }
        .input-number-container {
          // width: 100px;
        }
      }
    }
  }
  .goods-detail {
    .detail-title {
      line-height: 30px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      margin-bottom: 30px;
    }
    .detail-content {
      width: 100%;
      overflow: hidden;
    }
  }
  .qrcode {
    width: 144px;
    height: 144px;
    margin: 0 auto;
  }
  .qrcode-tip {
    line-height: 40px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-top: 20px;
  }
  .video-wrapper {
    height: 100%;
    display: flex;
    align-items: center;
    background: rgba(0, 0, 0, 1);
  }
</style>